import bem from 'utils/bem';

export const block = bem('apps-settings');
